export default "__VITE_PUBLIC_ASSET__5e0c348f__"